import { runListenersForEvent as userTypingHelpers } from 'core_main/globals/events';
import { ON_AGENT_TYPING_ACTIVITY } from 'core/constants';
import { UserAttributes } from 'core_main/api/users/types';
import { SignalEvent } from 'pubnub';

import { UserTypingResponse, UserTypingOptions } from '../types';
import { USER_TYPING, AI_ASSISTANT_USER_TYPING } from '../constants';

export const createUserTypingResponse = (
  event,
  user: UserAttributes,
  typingOpts?: UserTypingOptions,
): UserTypingResponse => {
  const { channel, message } = event;

  const conversationId = channel.split('.convo-')[1];

  const typing =
    message === USER_TYPING || message === AI_ASSISTANT_USER_TYPING;

  return {
    conversationId,
    user,
    typing,
    typingOpts,
  };
};

export const runListenersForUserTypingEvent = (
  signalEvent: SignalEvent,
  user: UserAttributes,
  opts?: UserTypingOptions,
) => {
  const callbackResponse = createUserTypingResponse(signalEvent, user, opts);
  userTypingHelpers(ON_AGENT_TYPING_ACTIVITY, callbackResponse);
};
